<template>
  <div class="transition">
    <BasicText size="h5">Quel est le type de public concerné ?</BasicText>
    <div class="transition-items">
      <div
        v-for="item in props.in.typePublics"
        :key="item.code"
      >
        <BasicCheckbox
          :label="item.intitule"
          :model-value="estRadionOn(item)"
          @update:model-value="updateOut(item)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { LovItemDTO } from '@/features/api/extranet/dto/Lov'
  import type { TypePublic } from '@/features/domaine/types/opco'
  import type { HabilitationsDTO } from '@/features/api/extranet/dto/Demande/shared'

  const props = defineProps<CarteProps<HabilitationsDTO, LovItemDTO<TypePublic>>>()
  const emits = defineEmits<CarteEvents<LovItemDTO<TypePublic>>>()

  const estRadionOn = (item: LovItemDTO<TypePublic>) => {
    return props.out?.code === item.code
  }

  const updateOut = (item: LovItemDTO<TypePublic>) => {
    emits('outChanged', true, item)
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
